module.exports = __webpack_public_path__ + "img/718.a4721382.png";